import { createSharedComposable } from '@vueuse/shared';
import type { PaginationQuery, PaginatedResponse } from '@/app/shared/types';
import { useApiClient } from '@/app/core/api-client';
import type { UiState } from '../../interfaces';

export const useUiStatesApi = createSharedComposable(() => {
  const { transport } = useApiClient();

  function getUiStates(params?: PaginationQuery & { key?: string }) {
    return transport.get<PaginatedResponse<UiState>>('v1/user/ui_states', {
      params,
    });
  }

  function saveUiState(payload: { key: string; value: unknown }) {
    return transport.post<{ data: UiState }>('v1/user/ui_states', payload);
  }

  function deleteAllUiStates() {
    return transport.delete('v1/user/ui_states');
  }

  function deleteUiState(id: string) {
    return transport.delete(`v1/user/ui_states/${id}`);
  }

  // Mostly for debugging purpose
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.deleteUiState = (id: string) => {
    deleteUiState(id);
  };

  return {
    getUiStates,
    saveUiState,
    deleteAllUiStates,
    deleteUiState,
  };
});
